import type { GenericFormType } from '@neo/blocks/forms/types'
import { Button } from '@neo/index'
import { Select } from '@neo/primitives/select'
import { Tooltip } from '@neo/primitives/tooltip'
import { Info, Minus, Plus } from 'lucide-react'
import { useState } from 'react'
import type { CreateTaskNodeData } from '../../types'

export const Configuration = ({
  form,
}: {
  form: GenericFormType<CreateTaskNodeData['config']>
}) => {
  const [count, setCount] = useState(form.state.values.due_date.due_date_time_value)
  const [period, setPeriod] = useState<'hours' | 'days'>(
    form.state.values.due_date.due_date_time_unit,
  )

  const incrementCount = () => {
    setCount((prev) => prev + 1)
    form.setFieldValue('due_date.due_date_time_value', count + 1)
  }

  const decrementCount = () => {
    if (count > 1) {
      setCount((prev) => prev - 1)
      form.setFieldValue('due_date.due_date_time_value', count - 1)
    }
  }

  return (
    <div className="col-span-1">
      <div className="flex-1">
        <div className="flex items-center gap-2 h-5">
          <span className="text-s-500 text-secondary h-[13px] mb-2.5">Due in</span>
          <span className="text-status-danger">*</span>
          <Tooltip content="Due date will be considered as ‘Task created date + X hrs/days’">
            <Info className="h-2.5 w-2.5 text-muted-foreground" />
          </Tooltip>
        </div>
        <div className="flex items-start gap-2">
          <div
            className="flex items-center rounded-lg border border-st2 bg-background"
            role="spinbutton"
            aria-label="Due date"
          >
            <Button
              type="button"
              variant="ghost"
              size="icon"
              data-testid="button-decrement"
              className="h-9 border-st2 hover:bg-hv1"
              onClick={decrementCount}
            >
              <Minus className="h-4 w-4 text-muted-foreground" />
            </Button>
            <span className="flex h-9 items-center justify-center font-jetbrains text-p-500 tabular-nums">
              {count}
            </span>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              data-testid="button-increment"
              className="h-9 border-st2 hover:bg-hv1"
              onClick={incrementCount}
            >
              <Plus className="h-4 w-4 text-muted-foreground" />
            </Button>
          </div>
          <Select
            name="period"
            data-testid="select-period"
            value={period}
            searchable={false}
            options={[
              { label: 'hour(s)', value: 'hours' },
              { label: 'day(s)', value: 'days' },
            ]}
            onChange={(value) => {
              setPeriod(value as 'hours' | 'days')
              form.setFieldValue('due_date.due_date_time_unit', value as 'hours' | 'days')
            }}
          />
        </div>
      </div>
    </div>
  )
}
